import * as React from 'react';
import styles from "./Box.module.css"

type BoxType = 'marketing' | 'notify' |'notifyThemeColoredText' | 'white' | 'whiteThemeColoredText' | 'subtle' | 'gradient' | 'flippedGradient' | 'whiteShadow';
type Padding = 'default' | 'small' | 'none';

type boxProps = {
  children?: React.ReactNode;
  type: BoxType,
  padding?: Padding,
  className?: string
}

function getClassName(direction: BoxType): string {
  switch (direction) {
    case 'marketing':
      return `${styles.box} ${styles.boxMarketing}`;
    case 'notify':
      return `${styles.box} ${styles.box200}`;
    case 'notifyThemeColoredText':
        return `${styles.box} ${styles.box200ThemedTextColor}`;
    case 'subtle':
      return `${styles.box} ${styles.boxSubtle}`;
    case 'white':
      return `${styles.box} ${styles.boxWhite}`;
    case 'whiteThemeColoredText':
        return `${styles.box} ${styles.boxWhiteThemedTextColor}`;
    case 'gradient':
      return `${styles.box} ${styles.gradientInner}`;
    case 'flippedGradient':
      return `${styles.box} ${styles.gradientInner}`;
    case 'whiteShadow':
      return `${styles.box} ${styles.boxWhiteShadow}`;
    default:
      return `${styles.box} ${styles.boxSubtle}`;
  }
}

function getPadding(direction: Padding): string {
  switch (direction) {
    case 'small':
      return `${styles.boxSmall}`;
    case 'none':
      return "";
    default:
      return `${styles.boxDefault}`;
  }
}

type combinedBoxProps = boxProps &  React.HTMLAttributes<HTMLDivElement>;

type clickableBoxProps = {
  onClick: () => void;
  nameforuitesting: string;
}


export function ClickableBox({children, onClick, ...props}: clickableBoxProps & combinedBoxProps) {
  return <Box data-nameforuitesting={props.nameforuitesting} onKeyDown={(e) => {
    if (e.nativeEvent.key ==='Enter') {
      onClick();
    }
  }} tabIndex={0} onClick={onClick}  {...props}>
    {children}
    </Box>
}

export function Box({ children, type, padding = "default", className = '', ...props }: combinedBoxProps) {
  return (
    <div className={`${type === "gradient" ? styles.gradient : styles.boxWrapper} ${type === "flippedGradient" ? styles.flippedGradient : styles.boxWrapper} ${className !== '' && className}`} {...props}>
      <div className={`${getClassName(type)} ${getPadding(padding)}`}>
        {children}
      </div>
      {type === 'marketing' && <svg className={styles.svg} width="463" height="453" viewBox="0 0 463 453" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f_547_27021)">
          <circle cx="226.5" cy="226.5" r="76.5" fill="var(--color-800)" />
        </g>
        <defs>
          <filter id="filter0_f_547_27021" x="0" y="0" width="453" height="453" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_547_27021" />
          </filter>
        </defs>
      </svg>}
    </div>
  );
}